import { configureStore } from '@reduxjs/toolkit';

import sharedSlices from './slice';

const store = configureStore({
  reducer: {
    ...sharedSlices
  },
  middleware: (getDefaultMiddleware: any) => {
    return getDefaultMiddleware({
      serializableCheck: false
    });
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
